import { render } from "./Programs.vue?vue&type=template&id=f4d387dc&scoped=true"
import script from "./Programs.vue?vue&type=script&lang=js"
export * from "./Programs.vue?vue&type=script&lang=js"

import "./Programs.vue?vue&type=style&index=0&id=f4d387dc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4d387dc"]])

export default __exports__